import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  id: "kt_aside_menu_wrapper",
  ref: "scrollElRef",
  class: "hover-scroll-overlay-y my-5 my-lg-5",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-dependencies": "#kt_aside_logo, #kt_aside_footer",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-offset": "0",
  "data-kt-scroll-wrappers": "#kt_aside_menu"
}
const _hoisted_2 = {
  id: "#kt_header_menu",
  class: "menu menu-column menu-title-gray-800 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500",
  "data-kt-menu": "true"
}
const _hoisted_3 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_4 = { class: "menu-content text-muted mb-0 fs-7 text-uppercase" }
const _hoisted_5 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_6 = { class: "menu-title" }
const _hoisted_7 = { class: "menu-link py-2" }
const _hoisted_8 = { class: "menu-title" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "menu-arrow" }, null, -1)
const _hoisted_10 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_12 = { class: "menu-title" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "menu-item" }, [
  /*#__PURE__*/_createVNode("div", { class: "h-30px" })
], -1)
const _hoisted_14 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_15 = { class: "menu-content pt-8 pb-2" }
const _hoisted_16 = { class: "menu-section text-unmuted text-uppercase fs-8 ls-1" }
const _hoisted_17 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_18 = {
  key: 0,
  class: "menu-icon"
}
const _hoisted_19 = {
  key: 1,
  class: "svg-icon svg-icon-2"
}
const _hoisted_20 = { class: "menu-title" }
const _hoisted_21 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_22 = {
  key: 0,
  class: "menu-icon"
}
const _hoisted_23 = {
  key: 1,
  class: "svg-icon svg-icon-2"
}
const _hoisted_24 = { class: "menu-title" }
const _hoisted_25 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_26 = {
  key: 0,
  class: "menu-icon"
}
const _hoisted_27 = {
  key: 1,
  class: "svg-icon svg-icon-2"
}
const _hoisted_28 = { class: "menu-title" }
const _hoisted_29 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_30 = {
  key: 0,
  class: "menu-icon"
}
const _hoisted_31 = {
  key: 1,
  class: "svg-icon svg-icon-2"
}
const _hoisted_32 = { class: "menu-title" }
const _hoisted_33 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_34 = {
  key: 0,
  class: "menu-icon"
}
const _hoisted_35 = {
  key: 1,
  class: "svg-icon svg-icon-2"
}
const _hoisted_36 = { class: "menu-title" }
const _hoisted_37 = {
  key: 1,
  class: "menu-badge"
}
const _hoisted_38 = {
  key: 5,
  class: "menu-item"
}
const _hoisted_39 = {
  key: 0,
  class: "menu-icon"
}
const _hoisted_40 = {
  key: 1,
  class: "svg-icon svg-icon-2"
}
const _hoisted_41 = { class: "menu-title" }
const _hoisted_42 = { class: "menu-link" }
const _hoisted_43 = {
  key: 0,
  class: "menu-icon"
}
const _hoisted_44 = {
  key: 1,
  class: "svg-icon svg-icon-2"
}
const _hoisted_45 = { class: "menu-title" }
const _hoisted_46 = /*#__PURE__*/_createVNode("span", { class: "menu-arrow" }, null, -1)
const _hoisted_47 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_48 = /*#__PURE__*/_createVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_49 = { class: "menu-title" }
const _hoisted_50 = { class: "menu-link" }
const _hoisted_51 = /*#__PURE__*/_createVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_52 = { class: "menu-title" }
const _hoisted_53 = /*#__PURE__*/_createVNode("span", { class: "menu-arrow" }, null, -1)
const _hoisted_54 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_55 = /*#__PURE__*/_createVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_56 = { class: "menu-title" }
const _hoisted_57 = /*#__PURE__*/_createVNode("div", { class: "menu-item" }, [
  /*#__PURE__*/_createVNode("div", { class: "menu-content" }, [
    /*#__PURE__*/_createVNode("div", { class: "separator mx-1 my-4" })
  ])
], -1)
const _hoisted_58 = {
  key: 0,
  class: "menu-item",
  style: {"margin-left":"25px !important"}
}
const _hoisted_59 = { class: "menu-icon" }
const _hoisted_60 = {
  key: 0,
  class: "bi bi-card-text fs-3"
}
const _hoisted_61 = { class: "menu-title" }
const _hoisted_62 = /*#__PURE__*/_createVNode("span", { class: "menu-icon" }, [
  /*#__PURE__*/_createVNode("i", {
    class: "bi bi-card-text fs-3",
    style: {"font-size":"18px !important","color":"rgb(255, 255, 255) !important"}
  }, " Open EC")
], -1)
const _hoisted_63 = {
  key: 1,
  class: "menu-item",
  style: {"margin-left":"25px !important"}
}
const _hoisted_64 = { class: "menu-icon" }
const _hoisted_65 = {
  key: 0,
  class: "bi bi-card-text fs-3"
}
const _hoisted_66 = /*#__PURE__*/_createVNode("span", { class: "menu-icon" }, [
  /*#__PURE__*/_createVNode("i", {
    class: "bi bi-shield fs-3",
    style: {"font-size":"18px !important","color":"rgb(255, 255, 255) !important"}
  }, " Override")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_inline_svg = _resolveComponent("inline-svg")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_ctx.isDocPage)
        ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.DocMenuConfig, (item, i) => {
            return (_openBlock(), _createBlock(_Fragment, { key: i }, [
              (item.heading)
                ? (_openBlock(), _createBlock("div", _hoisted_3, [
                    _createVNode("h4", _hoisted_4, _toDisplayString(_ctx.translate(item.heading)), 1)
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.pages, (menuItem, j) => {
                return (_openBlock(), _createBlock(_Fragment, { key: j }, [
                  (menuItem.heading)
                    ? (_openBlock(), _createBlock("div", _hoisted_5, [
                        _createVNode(_component_router_link, {
                          to: menuItem.route
                        }, {
                          default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                            _createVNode("a", {
                              class: [[isActive && 'active', isExactActive && 'active'], "menu-link py-2"],
                              href: href,
                              onClick: navigate
                            }, [
                              _createVNode("span", _hoisted_6, _toDisplayString(_ctx.translate(menuItem.heading)), 1)
                            ], 10, ["href", "onClick"])
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    : _createCommentVNode("", true),
                  (menuItem.sectionTitle)
                    ? (_openBlock(), _createBlock("div", {
                        key: 1,
                        class: [{ show: _ctx.hasActiveChildren(menuItem.route) }, "menu-item menu-accordion"],
                        "data-kt-menu-sub": "accordion",
                        "data-kt-menu-trigger": "click"
                      }, [
                        _createVNode("span", _hoisted_7, [
                          _createVNode("span", _hoisted_8, _toDisplayString(_ctx.translate(menuItem.sectionTitle)), 1),
                          _hoisted_9
                        ]),
                        _createVNode("div", {
                          class: [{ show: _ctx.hasActiveChildren(menuItem.route) }, "menu-sub menu-sub-accordion"]
                        }, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(menuItem.sub, (item2, k) => {
                            return (_openBlock(), _createBlock(_Fragment, { key: k }, [
                              (item2.heading)
                                ? (_openBlock(), _createBlock("div", _hoisted_10, [
                                    _createVNode(_component_router_link, {
                                      to: item2.route
                                    }, {
                                      default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                                        _createVNode("a", {
                                          class: [[
                          isActive && 'active',
                          isExactActive && 'active'
                        ], "menu-link py-2"],
                                          href: href,
                                          onClick: navigate
                                        }, [
                                          _hoisted_11,
                                          _createVNode("span", _hoisted_12, _toDisplayString(_ctx.translate(item2.heading)), 1)
                                        ], 10, ["href", "onClick"])
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ], 2)
                      ], 2))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128)),
              _hoisted_13
            ], 64))
          }), 128))
        : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pt == 'bibo' ? _ctx.MainMenuConfig_BIBO : ( _ctx.pt == 'ecc' ? _ctx.MainMenuConfig_ECC : ( _ctx.pt == 'pcp' ? _ctx.MainMenuConfig_PCP :_ctx.MainMenuConfig)), (item, i) => {
              return (_openBlock(), _createBlock(_Fragment, { key: i }, [
                (item.heading)
                  ? (_openBlock(), _createBlock("div", _hoisted_14, [
                      _createVNode("div", _hoisted_15, [
                        _createVNode("span", _hoisted_16, [
                          (item.heading === 'networkmenu' )
                            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                (_ctx.packagetype !== 'BIBO')
                                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(_toDisplayString(_ctx.translate(item.heading)), 1)
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.pages, (menuItem, j) => {
                  return (_openBlock(), _createBlock(_Fragment, { key: j }, [
                    (menuItem.heading)
                      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                          (menuItem.heading === 'autopma')
                            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                (_ctx.isShowAutoPMA === 'true')
                                  ? (_openBlock(), _createBlock("div", _hoisted_17, [
                                      _createVNode(_component_router_link, {
                                        to: menuItem.route
                                      }, {
                                        default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                                          _createVNode("a", {
                                            class: [[isActive && 'active', isExactActive && 'active'], "menu-link"],
                                            href: href,
                                            onClick: navigate
                                          }, [
                                            (menuItem.svgIcon || menuItem.fontIcon)
                                              ? (_openBlock(), _createBlock("span", _hoisted_18, [
                                                  (_ctx.asideMenuIcons === 'font')
                                                    ? (_openBlock(), _createBlock("i", {
                                                        key: 0,
                                                        class: [menuItem.fontIcon, "bi fs-3"]
                                                      }, null, 2))
                                                    : (_ctx.asideMenuIcons === 'svg')
                                                      ? (_openBlock(), _createBlock("span", _hoisted_19, [
                                                          _createVNode(_component_inline_svg, {
                                                            src: menuItem.svgIcon
                                                          }, null, 8, ["src"])
                                                        ]))
                                                      : _createCommentVNode("", true)
                                                ]))
                                              : _createCommentVNode("", true),
                                            _createVNode("span", _hoisted_20, _toDisplayString(_ctx.translate(menuItem.heading)), 1)
                                          ], 10, ["href", "onClick"])
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : (menuItem.heading === 'genealogy' || menuItem.heading === 'ppssetup')
                              ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                  (_ctx.packagetype !== 'BIBO')
                                    ? (_openBlock(), _createBlock("div", _hoisted_21, [
                                        _createVNode(_component_router_link, {
                                          to: menuItem.route
                                        }, {
                                          default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                                            _createVNode("a", {
                                              class: [[isActive && 'active', isExactActive && 'active'], "menu-link"],
                                              href: href,
                                              onClick: navigate
                                            }, [
                                              (menuItem.svgIcon || menuItem.fontIcon)
                                                ? (_openBlock(), _createBlock("span", _hoisted_22, [
                                                    (_ctx.asideMenuIcons === 'font')
                                                      ? (_openBlock(), _createBlock("i", {
                                                          key: 0,
                                                          class: [menuItem.fontIcon, "bi fs-3"]
                                                        }, null, 2))
                                                      : (_ctx.asideMenuIcons === 'svg')
                                                        ? (_openBlock(), _createBlock("span", _hoisted_23, [
                                                            _createVNode(_component_inline_svg, {
                                                              src: menuItem.svgIcon
                                                            }, null, 8, ["src"])
                                                          ]))
                                                        : _createCommentVNode("", true)
                                                  ]))
                                                : _createCommentVNode("", true),
                                              _createVNode("span", _hoisted_24, _toDisplayString(_ctx.translate(menuItem.heading)), 1)
                                            ], 10, ["href", "onClick"])
                                          ]),
                                          _: 2
                                        }, 1032, ["to"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              : (menuItem.heading === 'mgpay')
                                ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                                    (_ctx.ccode === 0)
                                      ? (_openBlock(), _createBlock("div", _hoisted_25, [
                                          _createVNode(_component_router_link, {
                                            to: menuItem.route
                                          }, {
                                            default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                                              _createVNode("a", {
                                                class: [[isActive && 'active', isExactActive && 'active'], "menu-link"],
                                                href: href,
                                                onClick: navigate
                                              }, [
                                                (menuItem.svgIcon || menuItem.fontIcon)
                                                  ? (_openBlock(), _createBlock("span", _hoisted_26, [
                                                      (_ctx.asideMenuIcons === 'font')
                                                        ? (_openBlock(), _createBlock("i", {
                                                            key: 0,
                                                            class: [menuItem.fontIcon, "bi fs-3"]
                                                          }, null, 2))
                                                        : (_ctx.asideMenuIcons === 'svg')
                                                          ? (_openBlock(), _createBlock("span", _hoisted_27, [
                                                              _createVNode(_component_inline_svg, {
                                                                src: menuItem.svgIcon
                                                              }, null, 8, ["src"])
                                                            ]))
                                                          : _createCommentVNode("", true)
                                                    ]))
                                                  : _createCommentVNode("", true),
                                                _createVNode("span", _hoisted_28, _toDisplayString(_ctx.translate(menuItem.heading)), 1)
                                              ], 10, ["href", "onClick"])
                                            ]),
                                            _: 2
                                          }, 1032, ["to"])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : (menuItem.heading === 'ustripmonitoring')
                                  ? (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
                                      (_ctx.isShowUSTrip === 'true')
                                        ? (_openBlock(), _createBlock("div", _hoisted_29, [
                                            _createVNode(_component_router_link, {
                                              to: menuItem.route
                                            }, {
                                              default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                                                _createVNode("a", {
                                                  class: [[isActive && 'active', isExactActive && 'active'], "menu-link"],
                                                  href: href,
                                                  onClick: navigate
                                                }, [
                                                  (menuItem.svgIcon || menuItem.fontIcon)
                                                    ? (_openBlock(), _createBlock("span", _hoisted_30, [
                                                        (_ctx.asideMenuIcons === 'font')
                                                          ? (_openBlock(), _createBlock("i", {
                                                              key: 0,
                                                              class: [menuItem.fontIcon, "bi fs-3"]
                                                            }, null, 2))
                                                          : (_ctx.asideMenuIcons === 'svg')
                                                            ? (_openBlock(), _createBlock("span", _hoisted_31, [
                                                                _createVNode(_component_inline_svg, {
                                                                  src: menuItem.svgIcon
                                                                }, null, 8, ["src"])
                                                              ]))
                                                            : _createCommentVNode("", true)
                                                      ]))
                                                    : _createCommentVNode("", true),
                                                  _createVNode("span", _hoisted_32, _toDisplayString(_ctx.translate(menuItem.heading)), 1)
                                                ], 10, ["href", "onClick"])
                                              ]),
                                              _: 2
                                            }, 1032, ["to"])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  : (menuItem.heading === 'PCP')
                                    ? (_openBlock(), _createBlock(_Fragment, { key: 4 }, [
                                        (_ctx.isShowPCPMenu === 'true')
                                          ? (_openBlock(), _createBlock("div", _hoisted_33, [
                                              _createVNode(_component_router_link, {
                                                to: menuItem.route
                                              }, {
                                                default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                                                  _createVNode("a", {
                                                    class: [[isActive && 'active', isExactActive && 'active'], "menu-link"],
                                                    href: href,
                                                    onClick: navigate
                                                  }, [
                                                    (menuItem.svgIcon || menuItem.fontIcon)
                                                      ? (_openBlock(), _createBlock("span", _hoisted_34, [
                                                          (_ctx.asideMenuIcons === 'font')
                                                            ? (_openBlock(), _createBlock("i", {
                                                                key: 0,
                                                                class: [menuItem.fontIcon, "bi fs-3"]
                                                              }, null, 2))
                                                            : (_ctx.asideMenuIcons === 'svg')
                                                              ? (_openBlock(), _createBlock("span", _hoisted_35, [
                                                                  _createVNode(_component_inline_svg, {
                                                                    src: menuItem.svgIcon
                                                                  }, null, 8, ["src"])
                                                                ]))
                                                              : _createCommentVNode("", true)
                                                        ]))
                                                      : _createCommentVNode("", true),
                                                    _createVNode("span", _hoisted_36, _toDisplayString(_ctx.translate(menuItem.heading)), 1),
                                                    (_ctx.repositionCount > 0)
                                                      ? (_openBlock(), _createBlock("span", _hoisted_37, _toDisplayString(_ctx.repositionCount), 1))
                                                      : _createCommentVNode("", true)
                                                  ], 10, ["href", "onClick"])
                                                ]),
                                                _: 2
                                              }, 1032, ["to"])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ], 64))
                                    : (_openBlock(), _createBlock("div", _hoisted_38, [
                                        _createVNode(_component_router_link, {
                                          to: menuItem.route
                                        }, {
                                          default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                                            _createVNode("a", {
                                              class: [[isActive && 'active', isExactActive && 'active'], "menu-link"],
                                              href: href,
                                              onClick: navigate
                                            }, [
                                              (menuItem.svgIcon || menuItem.fontIcon)
                                                ? (_openBlock(), _createBlock("span", _hoisted_39, [
                                                    (_ctx.asideMenuIcons === 'font')
                                                      ? (_openBlock(), _createBlock("i", {
                                                          key: 0,
                                                          class: [menuItem.fontIcon, "bi fs-3"]
                                                        }, null, 2))
                                                      : (_ctx.asideMenuIcons === 'svg')
                                                        ? (_openBlock(), _createBlock("span", _hoisted_40, [
                                                            _createVNode(_component_inline_svg, {
                                                              src: menuItem.svgIcon
                                                            }, null, 8, ["src"])
                                                          ]))
                                                        : _createCommentVNode("", true)
                                                  ]))
                                                : _createCommentVNode("", true),
                                              _createVNode("span", _hoisted_41, _toDisplayString(_ctx.translate(menuItem.heading)), 1)
                                            ], 10, ["href", "onClick"])
                                          ]),
                                          _: 2
                                        }, 1032, ["to"])
                                      ]))
                        ], 64))
                      : _createCommentVNode("", true),
                    (menuItem.sectionTitle)
                      ? (_openBlock(), _createBlock("div", {
                          key: 1,
                          class: [{ show: _ctx.hasActiveChildren(menuItem.route) }, "menu-item menu-accordion"],
                          "data-kt-menu-sub": "accordion",
                          "data-kt-menu-trigger": "click"
                        }, [
                          _createVNode("span", _hoisted_42, [
                            (menuItem.svgIcon || menuItem.fontIcon)
                              ? (_openBlock(), _createBlock("span", _hoisted_43, [
                                  (_ctx.asideMenuIcons === 'font')
                                    ? (_openBlock(), _createBlock("i", {
                                        key: 0,
                                        class: [menuItem.fontIcon, "bi fs-3"]
                                      }, null, 2))
                                    : (_ctx.asideMenuIcons === 'svg')
                                      ? (_openBlock(), _createBlock("span", _hoisted_44, [
                                          _createVNode(_component_inline_svg, {
                                            src: menuItem.svgIcon
                                          }, null, 8, ["src"])
                                        ]))
                                      : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode("span", _hoisted_45, _toDisplayString(_ctx.translate(menuItem.sectionTitle)), 1),
                            _hoisted_46
                          ]),
                          _createVNode("div", {
                            class: [{ show: _ctx.hasActiveChildren(menuItem.route) }, "menu-sub menu-sub-accordion"]
                          }, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(menuItem.sub, (item2, k) => {
                              return (_openBlock(), _createBlock(_Fragment, { key: k }, [
                                (item2.heading)
                                  ? (_openBlock(), _createBlock("div", _hoisted_47, [
                                      _createVNode(_component_router_link, {
                                        to: item2.route
                                      }, {
                                        default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                                          _createVNode("a", {
                                            class: [[
                          isActive && 'active',
                          isExactActive && 'active'
                        ], "menu-link"],
                                            href: href,
                                            onClick: navigate
                                          }, [
                                            _hoisted_48,
                                            _createVNode("span", _hoisted_49, _toDisplayString(_ctx.translate(item2.heading)), 1)
                                          ], 10, ["href", "onClick"])
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ]))
                                  : _createCommentVNode("", true),
                                (item2.sectionTitle)
                                  ? (_openBlock(), _createBlock("div", {
                                      key: 1,
                                      class: [{ show: _ctx.hasActiveChildren(item2.route) }, "menu-item menu-accordion"],
                                      "data-kt-menu-sub": "accordion",
                                      "data-kt-menu-trigger": "click"
                                    }, [
                                      _createVNode("span", _hoisted_50, [
                                        _hoisted_51,
                                        _createVNode("span", _hoisted_52, _toDisplayString(_ctx.translate(item2.sectionTitle)), 1),
                                        _hoisted_53
                                      ]),
                                      _createVNode("div", {
                                        class: [{ show: _ctx.hasActiveChildren(item2.route) }, "menu-sub menu-sub-accordion"]
                                      }, [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(item2.sub, (item3, k) => {
                                          return (_openBlock(), _createBlock(_Fragment, { key: k }, [
                                            (item3.heading)
                                              ? (_openBlock(), _createBlock("div", _hoisted_54, [
                                                  _createVNode(_component_router_link, {
                                                    to: item3.route
                                                  }, {
                                                    default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                                                      _createVNode("a", {
                                                        class: ["menu-link", [
                                isActive && 'active',
                                isExactActive && 'active'
                              ]],
                                                        href: href,
                                                        onClick: navigate
                                                      }, [
                                                        _hoisted_55,
                                                        _createVNode("span", _hoisted_56, _toDisplayString(_ctx.translate(item3.heading)), 1)
                                                      ], 10, ["href", "onClick"])
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["to"])
                                                ]))
                                              : _createCommentVNode("", true)
                                          ], 64))
                                        }), 128))
                                      ], 2)
                                    ], 2))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 128))
                          ], 2)
                        ], 2))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ], 64))
            }), 128)),
            _hoisted_57,
            (_ctx.pt != 'bibo' && _ctx.pt != 'ecc' && _ctx.pt != 'pcp')
              ? (_openBlock(), _createBlock("div", _hoisted_58, [
                  _createVNode(_component_router_link, {
                    class: "menu-link",
                    to: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode("span", _hoisted_59, [
                        (_ctx.asideMenuIcons === 'font')
                          ? (_openBlock(), _createBlock("i", _hoisted_60))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode("span", _hoisted_61, _toDisplayString(_ctx.current_usid), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, {
                    to: { name: 'openec'},
                    target: "_blank"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_62
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (_ctx.override)
              ? (_openBlock(), _createBlock("div", _hoisted_63, [
                  _createVNode(_component_router_link, {
                    class: "menu-link",
                    to: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode("span", _hoisted_64, [
                        (_ctx.asideMenuIcons === 'font')
                          ? (_openBlock(), _createBlock("i", _hoisted_65))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, { to: "/override/" }, {
                    default: _withCtx(() => [
                      _hoisted_66
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ], 64))
    ])
  ], 512))
}